import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

@Component({
  selector: 'dojo-option-label',
  standalone: true,
  template: `
    @if (label()) {
      <span class="text-md text-primary mt-[-1px] flex items-center">{{ label() }}</span>
    }
  `,
  host: { class: 'flex' },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OptionLabelComponent {
  readonly index = input.required<number>();

  readonly labelMap = new Map<number, string>([
    [0, 'A'],
    [1, 'B'],
    [2, 'C'],
    [3, 'D'],
    [4, 'E'],
    [5, 'F'],
    [6, 'G'],
    [7, 'H'],
    [8, 'I'],
    [9, 'J'],
    [10, 'K'],
  ]);

  readonly label = computed(() => this.labelMap.get(this.index()));
}
